import React, { memo, SVGProps } from 'react'

export const FileUpload = memo((props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M22.12 6.74999L16.04 0.66999C15.92 0.54999 15.76 0.48999 15.6 0.48999H2.32999C1.98999 0.48999 1.70999 0.76999 1.70999 1.10999V22.89C1.70999 23.23 1.98999 23.51 2.32999 23.51H21.67C22.01 23.51 22.29 23.23 22.29 22.89V7.18999C22.29 7.01999 22.22 6.86999 22.11 6.74999H22.12ZM21.05 22.27H2.95999V1.73999H15.34L21.05 7.44999V22.27Z"
      fill="currentColor"
    />
    <path
      d="M11.76 7.14999L7.41999 11.69C7.21999 11.9 7.36999 12.25 7.65999 12.25H8.85999C9.03999 12.25 9.18999 12.4 9.18999 12.58V16.76C9.18999 16.94 9.33999 17.09 9.51999 17.09H14.47C14.65 17.09 14.8 16.94 14.8 16.76V12.58C14.8 12.4 14.95 12.25 15.13 12.25H16.33C16.62 12.25 16.77 11.9 16.57 11.69L12.23 7.14999C12.1 7.00999 11.88 7.00999 11.75 7.14999H11.76Z"
      fill="currentColor"
    />
  </svg>
))
